import React from 'react';
import linkifyIt from 'linkify-it';
import tlds from 'tlds';
import {isSafeHref} from '../../forecast-app/shared/components/rich-text-editor-draftjs-wrapper/draftjsToHtml/js/safeHref';

const linkify = linkifyIt();
linkify.tlds(tlds);

export default readOnly => {
	return {
		decorators: [
			{
				// Normal links
				strategy: (contentBlock, callback) => {
					const links = linkify.match(contentBlock.get('text'));
					if (typeof links !== 'undefined' && links !== null) {
						for (let i = 0; i < links.length; i += 1) {
							callback(links[i].index, links[i].lastIndex);
						}
					}
				},
				component: props => {
					const links = linkify.match(props.decoratedText);
					const href = links && links[0] ? links[0].url : '';
					return (
						<a
							href={href}
							target="_blank"
							rel="noopener noreferrer"
							style={{cursor: 'pointer'}}
							onClick={() => {
								if (!readOnly) {
									window.open(href, '_blank');
								}
							}}
						>
							{props.children}
						</a>
					);
				},
			},
			{
				// LINK entity ranges
				strategy: (contentBlock, callback, contentState) => {
					contentBlock.findEntityRanges(character => {
						const entityKey = character.getEntity();
						return entityKey !== null && contentState.getEntity(entityKey).getType() === 'LINK';
					}, callback);
				},
				component: props => {
					const {href} = props.contentState.getEntity(props.entityKey).getData();
					return (
						<a
							href={href}
							target="_blank"
							style={{cursor: 'pointer'}}
							onClick={() => {
								if (!readOnly) {
									window.open(href, '_blank');
								}
							}}
						>
							{props.children}
						</a>
					);
				},
			},
			{
				// JIRA inlinecard links
				strategy: (contentBlock, callback, contentState) => {
					contentBlock.findEntityRanges(character => {
						const entityKey = character.getEntity();
						return entityKey !== null && contentState.getEntity(entityKey).getType() === 'JIRA_INLINECARD';
					}, callback);
				},
				component: props => {
					// `url` as well as `href`: a card authored in Jira carries only url, because
					// the sync stores the raw ADF inlineCard attrs verbatim.
					const {href, url} = props.contentState.getEntity(props.entityKey).getData();
					const candidate = href ?? url;
					// The href MUST be validated here. This decorator has no serializer in front
					// of it — it puts the value straight into an <a href> and a window.open — and
					// `url` arrives from the Jira sync, which stores ADF inlineCard attrs verbatim
					// with no validation. Without this guard a `javascript:` URL in a synced Jira
					// description would execute in the Forecast origin on click. Unsafe values
					// render as plain text, matching the HTML emit path; the allowlist is shared
					// with it via isSafeHref so the two cannot drift.
					const cardHref = isSafeHref(candidate) ? candidate : null;
					if (!cardHref) {
						return <span>{props.children}</span>;
					}
					return (
						<a
							href={cardHref}
							target="_blank"
							style={{cursor: 'pointer'}}
							onClick={() => {
								if (!readOnly) {
									window.open(cardHref, '_blank');
								}
							}}
						>
							{props.children}
						</a>
					);
				},
			},
		],
	};
};
